import { Label } from 'recharts';
import type { LabelProps } from 'recharts';

import { CHART_BAR_FALLBACK, NULL_VALUE_LABEL } from '../shared/chart-tokens';

export const BarChartValueLabel = (props: LabelProps) => (
  <Label
    {...props}
    fill={
      props.value === NULL_VALUE_LABEL
        ? CHART_BAR_FALLBACK.nullLabelFill
        : props.fill
    }
  />
);
